import { BUTTON_SIZE, SizeType } from '@/constants/buttonSizes';

interface TextButtonProps {
  text: string;
  onClick?: () => void;
  className?: string;
  size?: SizeType;
}

const TextButton = ({ text, size, onClick, className = '' }: TextButtonProps) => {
  return (
    <button type="button" className={`${className} ${size && BUTTON_SIZE[size]}`} onClick={onClick}>
      {text}
    </button>
  );
};

export default TextButton;
